import React, { useState } from 'react';
import { Steps, Button } from 'antd';
import I9Form from '../Web/I9Form';
import WorkmenDetails from '../I9Submissions/WorkmanDetails/index';
import { updateFormResonse } from '../../../api/dynamicForm';
import { useParams } from 'react-router-dom';

const { Step } = Steps;

const MainRouter = () => {
  const [current, setCurrent] = useState(0);
  const { id } = useParams();
  console.log("idddddd",id)
  

  // State to collect I9Form data
  const [i9FormData, setI9FormData] = useState({});

  const steps = [
    {
      title: "I9 Form",
      content: (
        <I9Form
          value={i9FormData}
          onChange={setI9FormData}
        />
      ),
    },
    {
      title: "Workman Details",
      content: (
        <WorkmenDetails
          i9Data={i9FormData}
        />
      ),
    },
  ];

  const next = async () => {
    if (current === 0) {
      // Prepare payload: convert dayjs dob to ISO string if needed
      const payload = {
        "jobDetails&I9Section1": {
          ...i9FormData,
        },
        // id:'68d0e8f50787526a24253e4c',
                  id:i9FormData?.id,


      };
      console.log("I9Form Data on Next:", payload);
      // Call API with payload
      try {
        const response = await updateFormResonse(payload);
        console.log("updateFormResonse response:", response);
      } catch (err) {
        console.error("Error in updateFormResonse:", err);
      }
    }
    setCurrent((c) => Math.min(c + 1, steps.length - 1));
  };
  const prev = () => setCurrent((c) => Math.max(c - 1, 0));

  return (
    <div>
      <Steps current={current} style={{ marginBottom: 40 }}>
        {steps.map((item, idx) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      <div style={{ minHeight: 320 }}>{steps[current].content}</div>
      <div style={{ textAlign: "right", marginTop: 16 }}>
        <Button onClick={prev} hidden={current === 0} style={{ marginRight: 170 }}>
          Previous
        </Button>
        <Button type="primary" onClick={next} hidden={current === steps.length - 1}>
          {current === steps.length - 1 ? "Finish" : "Next"}
        </Button>
      </div>
    </div>
  );
};

export default MainRouter;
